export default __webpack_public_path__ + "static/media/SeminarioIes2026_IgorValdebenito.e247149d.jpg";